export function ceilTo(x: number, roundTo: number): number {
  return Math.ceil(x / roundTo) * roundTo;
}
